import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ adminOnly = false }) {
  const { user, loading } = useAuth();

  // Wait for auth context to finish loading
  if (loading) {
    return (
      <div className="page-loader">
        Loading...
      </div>
    );
  }

  // If no user session → redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If route requires admin but user is not admin
  if (adminOnly && !user.can_admin) {
    return <Navigate to="/dashboard/hrmcrm" replace />;
  }

  // Allow access
  return <Outlet />;
}